import { Box, Chip, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { Button } from "react-admin";
import React from 'react'

function MultiChefitServeListDialog(props: any) {

    const handleCancel = () => {
        props.setOpen(false);
    };
    console.log(props.serveListData);
    return (
        <div>
        <Dialog open={props.open}>
          <DialogTitle> {"Available Slots"} </DialogTitle>
          <DialogContent>
            <Box display={"flex"} gap={"0.5rem"} flexWrap={"wrap"} alignItems={'center'}>
                {
                    props?.serveListData && props?.serveListData.length>0 ? props?.serveListData.map((slot:any,i:number)=>(
                        slot?.isAvailable === true?<Chip label={slot?.date+" "+ slot?.time} color='primary'/>
                        :<Chip label={slot?.date+" "+ slot?.time} color='error'/>
                    )):"NO Slots Available"
                }
            </Box>
          </DialogContent>
          <DialogActions>
          <Button
            onClick={() => {
              handleCancel();
            }}
            variant="contained"
            color="primary"
            label="Close"
          />
          </DialogActions>
        </Dialog>
      </div>
    )
}

export default MultiChefitServeListDialog
